/* eslint-disable no-param-reassign */
import axios from "axios";
import { $toast } from "vuetify-snackbar-toast";
import router from "@/router";
import authService from "@/Services/AuthService";

function getCsrfToken() {
  const cookieList = document.cookie.split(";").filter((str) => str.includes("csrftoken"));
  if (cookieList.length > 0) {
    const cookie = cookieList[0].replace("csrftoken=", "").trim();
    return cookie;
  }
  return null;
}

export default () => {
  const options = { baseURL: process.env.VUE_APP_API_HOST };
  const axiosInstance = axios.create(options);
  axiosInstance.interceptors.request.use((config) => {
    const token = authService.getAccessToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    const csrfToken = getCsrfToken();
    if (csrfToken) config.headers["X-CSRF-TOKEN"] = csrfToken;
    return config;
  });
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401 && authService.getAccessToken()) {
        $toast.warn("Sua sessão expirou");
        localStorage.setItem("originRoute", router.currentRoute.fullPath);
        const currentRouteName = router.currentRoute.name;
        if (currentRouteName !== "login" && currentRouteName !== "logout") {
          router.push({ name: "logout" });
        }
        return Promise.reject(new Error("Sua sessão expirou"));
      }
      if (error.response && error.response.status === 403) {
        return Promise.reject(new Error("Você não tem permissão para acessar esse recurso"));
      }
      if (error.response && error.response.status === 404) {
        if (error.response.data instanceof ArrayBuffer) {
          try {
            const decoded = JSON.parse(new TextDecoder("utf-8").decode(error.response.data));
            const message =
              decoded.message ||
              decoded.error?.message ||
              "Nenhum registro encontrado para o item pesquisado.";
            return Promise.reject(new Error(message));
          } catch (e) {
            return Promise.reject(new Error("Nenhum registro encontrado para o item pesquisado."));
          }
        } else {
          const message =
            error.response.data?.message ||
            error.response.data?.error?.message ||
            "Nenhum registro encontrado para o item pesquisado.";
          return Promise.reject(new Error(message));
        }
      }
      if (error.response && error.response.status === 422) {
        if (error.response.data instanceof ArrayBuffer) {
          try {
            const decoded = JSON.parse(new TextDecoder("utf-8").decode(error.response.data));
            const message =
              decoded.message ||
              decoded.error?.message ||
              "Não foi possível processar a solicitação.";
            return Promise.reject(new Error(message));
          } catch (e) {
            return Promise.reject(new Error("Não foi possível processar a solicitação."));
          }
        }
      }
      if (error.response) {
        if (error.response.data) {
          const data = error.response.data;
          return Promise.reject(data.error ?? data);
        }
      }
      return Promise.reject(error);
    }
  );
  return axiosInstance;
};
